import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse,
  headersWithoutAuthWithoutBody
} from "../../APIHelpers/Responses";

export const superAdminMetaServices = {
  getDiscoveryCategoryList,
  getDiscoverySubCategoryList,
  getAdminBlogPostList,
  getAdminSingleBlogPost,
  getIntegrationList,
  getSingleIntegrationDetails,
  getAddonList,
  getSingleAddonDetails
};

// Get Discovery Category
async function getDiscoveryCategoryList() {
  try {
    const signal = cancelPreviousRequest(`getDiscoveryCategoryList`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getDiscoveryCategoryList`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401 || data?.statusCode === 423){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Discovery Sub Category
async function getDiscoverySubCategoryList(categoryId) {
  try {
    const signal = cancelPreviousRequest(`getDiscoverySubCategoryList`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getDiscoverySubCategoryList/${categoryId}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if(data?.statusCode === 401 || data?.statusCode === 423){
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Admin Blog Post
async function getAdminBlogPostList(status, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getAdminBlogPostList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getAdminBlogPostList/${status}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getAdminBlogPostList/${status}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithoutAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Public Single Blog Post
async function getAdminSingleBlogPost(postId) {
  let apiURL = `${config.API_URL_USER_ONBOARDING}getAdminSingleBlogPost/${postId}`;
  const response = await fetch(apiURL, headersWithoutAuthWithoutBody("GET"));
  const result = await response.json();
  const data = decryptResponse(result);
  if (data?.statusCode === 401) {
    handleResponse(data)
  }
  return data;
}

// Get Integration List
async function getIntegrationList(search, filter, sort) {
  try {
    const signal = cancelPreviousRequest(`getIntegrationList`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getIntegrationList?search=${search || ""}&filter=${filter || ""}&sort=${sort || ""}`;
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Integration Details
async function getSingleIntegrationDetails(integrationId) {
  let apiURL = `${config.API_URL_USER_ONBOARDING}getSingleIntegrationDetails/${integrationId}`;
  const response = await fetch(apiURL, headersWithAuthWithoutBody("GET", headers));
  const result = await response.json();
  const data = decryptResponse(result);
  if (data?.statusCode === 401) {
    handleResponse(data)
  }
  return data;
}

// Get Addon List
async function getAddonList(search) {
  try {
    const signal = cancelPreviousRequest(`getAddonList`);
    let apiURL = `${config.API_URL_USER_ONBOARDING}getAddonList?search=${search || ""}`;
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Addon Details
async function getSingleAddonDetails(addonId) {
  let apiURL = `${config.API_URL_USER_ONBOARDING}getSingleAddonDetails/${addonId}`;
  const response = await fetch(apiURL, headersWithAuthWithoutBody("GET", headers));
  const result = await response.json();
  const data = decryptResponse(result);
  if (data?.statusCode === 401) {
    handleResponse(data)
  }
  return data;
}